export default "__VITE_ASSET__2_v5Ytnr__"